import { IconBusinessSolutions, IconBusinessSolutionsFilled, IconCompanies, IconCompaniesFilled, IconContact, IconContactFilled, IconContacts, IconContactsFilled, IconEvents, IconEventsFilled, IconGroups, IconGroupsFilled, IconHome, IconHomeFilled, IconJobs, IconJobsFilled, IconLogout, IconMessages, IconMessagesFilled, IconMore, IconNews, IconNewsFilled, IconNotificationCenter, IconNotificationFilled, IconOtherServices, IconOtherServicesFilled, IconPremium, IconPremiumFilled, IconProBusiness, IconProBusinessFilled, IconProJobs, IconProJobsFilled, IconRocket, IconSettings, } from '@xingternal/icons';
import postLogoutUser from './postLogoutUser';
const _premium = {
    proBusiness: {
        key: 'proBusiness',
        icon: IconProBusiness,
        activeIcon: IconProBusinessFilled,
        title: 'VERTICAL_NAVIGATION_PROBUSINESS',
        href: '/probusiness',
        notificationKey: 'probusinessNotifications',
        premium: true,
    },
    premiumUpsell: {
        key: 'premiumUpsell',
        icon: IconPremium,
        activeIcon: IconPremiumFilled,
        title: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER',
        titleShort: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT',
        href: '/premium',
        premium: true,
    },
    premium: {
        key: 'premium',
        icon: IconPremium,
        activeIcon: IconPremiumFilled,
        title: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS',
        titleShort: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT',
        href: '/premium',
        notificationKey: 'premiumPerksNew',
        premium: true,
    },
    proJobs: {
        key: 'proJobs',
        icon: IconProJobs,
        activeIcon: IconProJobsFilled,
        title: 'VERTICAL_NAVIGATION_MYPROJOBS',
        href: '/projobs/dashboard',
        premium: true,
    },
};
const _notificationCenterLink = {
    notificationCenterWeb: {
        key: 'notificationCenterWeb',
        icon: IconNotificationCenter,
        activeIcon: IconNotificationFilled,
        href: '/notification-center',
        title: 'NOTIFICATION_CENTER_LINK',
    },
};
const _upsellHeaderLinks = {
    premiumUpsellHeader: {
        key: 'premiumUpsellHeader',
        icon: IconPremiumFilled,
        activeIcon: IconPremiumFilled,
        href: '/upsell/premium?reagent=uplt_95',
        title: 'FRAME_HEADER_UPSELL_PREMIUM',
    },
    proJobsUpsellHeader: {
        key: 'proJobsUpsellHeader',
        icon: IconProJobsFilled,
        activeIcon: IconProJobsFilled,
        href: '/upsell/projobs?reagent=uplt_277',
        title: 'FRAME_HEADER_UPSELL_PROJOBS',
    },
};
const _topBarLinks = {
    messengerTopBar: {
        key: 'messengerTopBar',
        icon: IconMessages,
        activeIcon: IconMessagesFilled,
        title: 'VERTICAL_NAVIGATION_MESSAGES',
        href: '/chats',
        notificationKey: 'unseenMessages',
    },
};
const _personalLinks = {
    premiumUpsellPersonal: {
        key: 'premiumUpsellPersonal',
        icon: IconPremium,
        activeIcon: IconPremiumFilled,
        href: '/upsell/premium?reagent=uplt_284',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP',
    },
    proJobsPersonal: {
        key: 'proJobsPersonal',
        icon: IconProJobs,
        activeIcon: IconProJobsFilled,
        href: '/upsell/projobs?reagent=uplt_283',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP',
    },
    proJobsMemberPersonal: {
        key: 'proJobsMemberPersonal',
        href: '/projobs/start',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS',
    },
    coachProfilePersonal: {
        key: 'coachProfilePersonal',
        href: 'https://coaches.xing.com/coaches/meinprofil',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE',
    },
    xtmPersonal: {
        key: 'xtmPersonal',
        href: '/xtm',
        title: 'VERTICAL_NAVIGATION_HEADER_XTM',
    },
    seatManagerAdminPersonal: {
        key: 'seatManagerAdminPersonal',
        href: '/seat-manager',
        title: 'VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN',
    },
    jobsPosterPersonal: {
        key: 'jobsPosterPersonal',
        href: '/jobs/manage',
        title: 'VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS',
    },
    admasterUserPersonal: {
        key: 'admasterUserPersonal',
        href: '/xam/personal/ads',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS',
    },
    brandManagerEditor: {
        key: 'brandManagerEditor',
        href: '/brandmanager',
        title: 'VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR',
    },
};
const _menuLinks = {
    home: {
        key: 'home',
        icon: IconHome,
        activeIcon: IconHomeFilled,
        title: 'VERTICAL_NAVIGATION_STARTPAGE',
        href: '/',
        notificationKey: 'activities',
    },
    contacts: {
        key: 'contacts',
        icon: IconContacts,
        activeIcon: IconContactsFilled,
        title: 'VERTICAL_NAVIGATION_CONTACTS',
        titleShort: 'VERTICAL_NAVIGATION_CONTACTS_SHORT',
        href: '/network',
        notificationKey: 'contactRequests',
    },
    messages: {
        key: 'messages',
        icon: IconMessages,
        activeIcon: IconMessagesFilled,
        title: 'VERTICAL_NAVIGATION_MESSAGES',
        href: '/messenger',
        notificationKey: 'unreadChats',
    },
    menu: {
        key: 'more',
        icon: IconMore,
        title: 'VERTICAL_NAVIGATION_MORE',
    },
    jobs: {
        key: 'jobs',
        icon: IconJobs,
        activeIcon: IconJobsFilled,
        title: 'VERTICAL_NAVIGATION_FOOTER_JOB_MARKET',
        href: '/jobs',
        notificationKey: 'jobs',
    },
    events: {
        key: 'events',
        icon: IconEvents,
        activeIcon: IconEventsFilled,
        title: 'VERTICAL_NAVIGATION_EVENTS',
        href: '/events',
        notificationKey: 'events',
    },
    content: {
        key: 'content',
        icon: IconNews,
        activeIcon: IconNewsFilled,
        title: 'VERTICAL_NAVIGATION_CONTENT_PAGES',
        href: '/news',
        notificationKey: 'news',
    },
    groups: {
        key: 'groups',
        icon: IconGroups,
        activeIcon: IconGroupsFilled,
        title: 'VERTICAL_NAVIGATION_COMMUNITIES',
        href: '/communities',
        notificationKey: 'groupsWeb',
    },
    companies: {
        key: 'companies',
        icon: IconCompanies,
        activeIcon: IconCompaniesFilled,
        title: 'VERTICAL_NAVIGATION_COMPANIES',
        href: '/companies',
    },
    business: {
        key: 'business',
        icon: IconOtherServices,
        activeIcon: IconOtherServicesFilled,
        title: 'VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS',
        titleShort: 'VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT',
        href: '/business-solutions',
    },
    services: {
        key: 'services',
        icon: IconOtherServices,
        activeIcon: IconOtherServicesFilled,
        title: 'VERTICAL_NAVIGATION_OTHER_SERVICES',
        href: '/app/user?op=xing_services.other',
    },
    helpPersonal: {
        key: 'helpPersonal',
        href: '/help',
        title: 'VERTICAL_NAVIGATION_HEADER_HELP',
    },
    settingsPersonal: {
        key: 'settingsPersonal',
        href: '/settings',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS',
    },
    invoicesPersonal: {
        key: 'invoicesPersonal',
        href: '/payments/settings',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES',
    },
    logoutPersonal: {
        key: 'logoutPersonal',
        href: '/login/logout',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT',
        onClick: postLogoutUser,
    },
};
const _armstrongMenu = {
    homeArmstrong: {
        key: 'disco',
        icon: IconHome,
        activeIcon: IconHomeFilled,
        title: 'FRAME_NAVIGATION_SUPI',
        href: '/discover/updates',
    },
    discover: {
        key: 'supi',
        icon: IconContacts,
        activeIcon: IconContactsFilled,
        title: 'FRAME_NAVIGATION_NETWORKING_ICON_TEXT',
        href: '/network-home',
        notificationKey: 'networkHome',
    },
    me: {
        key: 'me-hub',
        icon: IconContact,
        activeIcon: IconContactFilled,
        title: 'FRAME_NAVIGATION_ME_HUB',
        href: '/notification-center',
        notificationKey: 'resonanceHub',
    },
    meV2: {
        key: 'me-hub',
        icon: IconContact,
        activeIcon: IconContactFilled,
        title: 'FRAME_NAVIGATION_ME_HUB',
        href: '/you',
        notificationKey: 'meHub',
    },
    jobsArmstrong: {
        key: 'jobs',
        icon: IconJobs,
        activeIcon: IconJobsFilled,
        title: 'FRAME_NAVIGATION_JOBS',
        href: '/jobs',
        notificationKey: 'jobs',
    },
    menu: _menuLinks.menu,
    premiumUpsellArmstrong: {
        key: 'premiumUpsellArmstrong',
        icon: IconPremium,
        activeIcon: IconPremiumFilled,
        title: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER',
        titleShort: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT',
        href: '/upsell/premium',
    },
    proJobsUpsellArmstrong: {
        key: 'proJobsUpsellArmstrong',
        icon: IconProJobs,
        activeIcon: IconProJobsFilled,
        href: '/upsell/projobs',
        title: 'VERTICAL_NAVIGATION_PROJOBS_UPSELL',
        titleShort: 'VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT',
    },
    businessArmstrong: {
        key: 'business',
        icon: IconBusinessSolutions,
        activeIcon: IconBusinessSolutionsFilled,
        title: 'VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS',
        titleShort: 'VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT',
        href: '/business-solutions',
    },
    premiumArmstrong: {
        key: 'premiumArmstrong',
        icon: IconPremium,
        activeIcon: IconPremiumFilled,
        title: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS',
        titleShort: 'VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT',
        href: '/premium',
        premium: true,
    },
    proJobsArmstrong: {
        key: 'proJobsArmstrong',
        icon: IconProJobs,
        activeIcon: IconProJobsFilled,
        title: 'VERTICAL_NAVIGATION_MYPROJOBS',
        href: '/projobs/dashboard',
        premium: true,
    },
    proBusinessArmstrong: {
        key: 'proBusinessArmstrong',
        icon: IconProBusiness,
        activeIcon: IconProBusinessFilled,
        title: 'VERTICAL_NAVIGATION_PROBUSINESS',
        href: '/probusiness',
        premium: true,
    },
    eventsArmstrong: {
        key: 'eventsArmstrong',
        icon: IconEvents,
        activeIcon: IconEventsFilled,
        title: 'VERTICAL_NAVIGATION_EVENTS',
        href: '/events',
    },
    contentArmstrong: {
        key: 'contentArmstrong',
        icon: IconNews,
        activeIcon: IconNewsFilled,
        title: 'VERTICAL_NAVIGATION_CONTENT_PAGES',
        href: '/news',
    },
    groupsArmstrong: {
        key: 'groupsArmstrong',
        icon: IconGroups,
        activeIcon: IconGroupsFilled,
        title: 'VERTICAL_NAVIGATION_COMMUNITIES',
        href: '/communities',
    },
    // Replace them with the real content when only Armstrong/SPA frames remains
    settingsPersonalArmstrong: {
        key: 'settingsPersonal',
        icon: IconSettings,
        href: '/settings',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS',
    },
    feedbackInfoV2Armstrong: {
        key: 'feedbackInfoV2Armstrong',
        icon: IconRocket,
        href: '/more/feedback-info',
        title: 'VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE',
        titleShort: 'VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT',
    },
    logoutPersonalArmstrong: {
        key: 'logoutPersonal',
        icon: IconLogout,
        href: '/login/logout',
        title: 'VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT',
        onClick: postLogoutUser,
    },
    fab: {
        key: 'fab',
        icon: IconMessages,
        activeIcon: IconMessagesFilled,
        href: '/messenger/chats/contacts',
    },
};
const _appLinks = {
    loginWithXing: {
        key: 'loginWithXing',
        title: 'VERTICAL_NAVIGATION_FOOTER_LOGINWXING',
        href: 'https://dev.xing.com/plugins/login_with',
    },
    shareButton: {
        key: 'shareButton',
        title: 'VERTICAL_NAVIGATION_FOOTER_XING_SHARE',
        href: 'https://www.xing.com/app/share?op=button_builder',
    },
    downloads: {
        key: 'downloads',
        title: 'VERTICAL_NAVIGATION_FOOTER_DOWNLOAD',
        href: 'https://www.xing.com/app/user?op=downloads',
    },
};
const _footerAppsLinks = {
    iphoneIpadFooter: {
        key: 'iphoneIpadFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD',
        href: 'https://itunes.apple.com/de/app/xing/id297625850?mt=8&ct=footer_Marketing&at=10lRnD',
    },
    androidFooter: {
        key: 'androidFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_ANDROID',
        href: 'https://play.google.com/store/apps/details?id=com.xing.android&referrer=utm_source%3DXINGWeb%26utm_medium%3DFooter',
    },
    windows10Footer: {
        key: 'windows10Footer',
        title: 'VERTICAL_NAVIGATION_FOOTER_WINDOWS_10',
        href: 'https://www.microsoft.com/de-de/p/xing/9wzdncrdxbkc?cid=mktmicrosite',
    },
};
const _footerCompanyLinks = {
    newWorkFooter: {
        key: 'newWorkFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_NEWWORKSE',
        href: {
            de: 'https://www.new-work.se/de',
            en: 'https://www.new-work.se/en',
        },
    },
    careersFooter: {
        key: 'careersFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_CAREER',
        href: {
            de: 'https://www.new-work.se/de/karriere/',
            en: 'https://www.new-work.se/en/career/',
        },
    },
    investorRelationsFooter: {
        key: 'investorRelationsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS',
        href: {
            de: 'https://www.new-work.se/de/investor-relations/',
            en: 'https://www.new-work.se/en/investor-relations/',
        },
    },
    pressFooter: {
        key: 'pressFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_PRESS',
        href: {
            de: 'https://www.new-work.se/de/newsroom/',
            en: 'https://www.new-work.se/en/newsroom/',
        },
    },
    newWorkExperienceFooter: {
        key: 'newWorkExperienceFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE',
        href: 'https://nwx.new-work.se',
        languages: ['Deutsch'],
    },
};
const _footerLegalLinks = {
    imprintFooter: {
        key: 'imprintFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_IMPRINT',
        href: 'https://www.xing.com/imprint',
    },
    tAndCFooter: {
        key: 'tAndCFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_TANDC',
        href: 'https://www.xing.com/terms',
    },
    privacyAtXingFooter: {
        key: 'privacyAtXingFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_PRIVACY',
        href: {
            de: 'https://privacy.xing.com/de',
            en: 'https://privacy.xing.com/en',
        },
    },
    privacyPolicyFooter: {
        key: 'privacyPolicyFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY',
        href: {
            de: 'https://privacy.xing.com/de/datenschutzerklaerung',
            en: 'https://privacy.xing.com/en/privacy-policy',
        },
    },
};
const _footerMainSectionsLinks = {
    peopleDirectoryFooter: {
        key: 'peopleDirectoryFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY',
        href: 'https://www.xing.com/people/',
    },
    jobsFooter: {
        key: 'jobsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_JOB_MARKET',
        href: 'https://www.xing.com/jobs',
    },
    eventsFooter: {
        key: 'eventsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_EVENTS',
        href: 'https://www.xing.com/events',
    },
    newsFooter: {
        key: 'newsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_XING_NEWS',
        href: 'https://www.xing.com/news',
    },
    groupsFooter: {
        key: 'groupsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_GROUPS',
        href: 'https://www.xing.com/communities',
    },
    companiesFooter: {
        key: 'companiesFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_COMPANIES',
        href: 'https://www.xing.com/companies',
    },
    coachesFooter: {
        key: 'coachesFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_COACHES',
        href: 'https://coaches.xing.com/',
    },
};
const _footerMembershipsLinks = {
    premiumOfferFooter: {
        key: 'premiumOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP',
        href: 'https://www.xing.com/upsell/premium_offers?reagent=uplt_98',
    },
    proJobsOfferFooter: {
        key: 'proJobsOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP',
        href: 'https://www.xing.com/upsell/projobs?reagent=uplt_205',
    },
};
const _footerResourcesLinks = {
    helpFooter: {
        key: 'helpFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_HELP',
        href: {
            de: 'https://faq.xing.com/de',
            en: 'https://faq.xing.com/en',
        },
    },
    xingCommunityFooter: {
        key: 'xingCommunityFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_COMMUNITY',
        href: 'https://www.xing.com/communities/groups/xing-community-1000150',
    },
    devBlogFooter: {
        key: 'devBlogFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_DEVBLOG',
        href: 'https://tech.xing.com/',
    },
    appsFooter: {
        key: 'appsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_APP_GALLERY',
        href: {
            de: 'https://mobile.xing.com/de/',
            en: 'https://mobile.xing.com/en/',
        },
    },
};
const _footerServicesLinks = {
    eRecruitingOfferFooter: {
        key: 'eRecruitingOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER',
        href: {
            de: 'https://recruiting.xing.com/de/',
            en: 'https://recruiting.xing.com/en/',
        },
    },
    halloFreelancerOfferFooter: {
        key: 'halloFreelancerOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER',
        href: 'https://www.hallofreelancer.com/',
        languages: ['Deutsch'],
    },
    advertisementOfferFooter: {
        key: 'advertisementOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_XAS',
        href: 'https://www.xing.com/xam/personal/ads',
    },
    marketingSolutionsOfferFooter: {
        key: 'marketingSolutionsOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_ADVERTISE',
        href: {
            de: 'https://werben.xing.com',
            en: 'https://advertising.xing.com',
        },
    },
    xingEventsOfferFooter: {
        key: 'xingEventsOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_AMIANDO',
        href: 'https://www.xing-events.com/',
    },
    curriculumVitaeEditorFooter: {
        key: 'curriculumVitaeEditorFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF',
        href: 'https://lebenslauf.com/',
    },
    coverLetterEditorFooter: {
        key: 'coverLetterEditorFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN',
        href: 'https://anschreiben.com/',
    },
    jobApplicationTipsFooter: {
        key: 'jobApplicationTipsFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_BEWERBUNG',
        href: 'https://bewerbung.com/',
    },
    kununuOfferFooter: {
        key: 'kununuOfferFooter',
        title: 'VERTICAL_NAVIGATION_FOOTER_KUNUNU',
        href: 'https://www.kununu.com/',
    },
};
const _footerOtherLinks = {
    mobileOffer: {
        key: 'mobileOffer',
        title: 'VERTICAL_NAVIGATION_FOOTER_MOBILE',
        href: 'https://mobile.xing.com/en/',
    },
    aboutFooter: {
        key: 'about',
        title: 'VERTICAL_NAVIGATION_FOOTER_XING_AG',
        href: {
            de: 'https://www.new-work.se/de/unternehmen',
            en: 'https://www.new-work.se/en/about-new-work-se',
        },
    },
    developersFooter: {
        key: 'developers',
        title: 'VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL',
        href: 'https://dev.xing.com/',
    },
};
export default {
    ..._menuLinks,
    ..._armstrongMenu,
    ..._premium,
    ..._upsellHeaderLinks,
    ..._topBarLinks,
    ..._personalLinks,
    ..._notificationCenterLink,
    // Footer
    ..._appLinks,
    ..._footerAppsLinks,
    ..._footerCompanyLinks,
    ..._footerLegalLinks,
    ..._footerMainSectionsLinks,
    ..._footerMembershipsLinks,
    ..._footerResourcesLinks,
    ..._footerServicesLinks,
    ..._footerOtherLinks,
};
//# sourceMappingURL=navigation.js.map